import axios from "axios";
import { MilestoneTask, MilestoneTasks } from "./types";
import { buildQueryString, QueryParam } from "../queryUtils";
import { baseUrl } from "../apiUrl";

// Get all milestones
export const getMilestonesTasks = async (...query: QueryParam[]): Promise<MilestoneTasks> => {
  try {
    let url = `${baseUrl}/clo-hms/homesite/milestones/tasks?${buildQueryString(query[0])}`;
    if (query.length > 1) {
      url = `${baseUrl}/clo-hms/homesite/milestones/tasks?${buildQueryString(query[0])}&${buildQueryString(query[1])}`
    }
    const response = await axios.get<MilestoneTasks>(url);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch milestones: ${error}`);
  }
};

// create milestone tasks
export const createMilestoneTasks = async (milestone: Partial<MilestoneTask>): Promise<MilestoneTask> => {
  try {
    const response = await axios.post<MilestoneTask>(`${baseUrl}/clo-hms/homesite/milestones/tasks`, milestone);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to create milestone tasks: ${error}`);
  }
};

// Update a specific milestone by ID
export const updateMilestoneTasks = async (milestone: Partial<MilestoneTask>[]): Promise<MilestoneTask[]> => {
  try {
    const response = await axios.patch<MilestoneTask[]>(`${baseUrl}/clo-hms/homesite/milestones/tasks`, milestone);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to update milestone with ID ${milestone}: ${error}`);
  }
};
